import { CreateResponsiveStyle, DEVICE_SIZES,useDeviceSize,} from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    container: {
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      marginTop: 10,
    },
    backBtnWidget: {
      flexDirection: "row",
      alignItems: "center",
    },
    alertModalOverlay:{
      backgroundColor: "white",
      width: 323,
      height: 200,
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    btnWrapper:{
      width: 123.5,
      height: 36,
      alignSelf: "center",
      marginTop: 20,
    },
    btnSpace:{marginLeft:20, width:'100%'},
    errorText:{
      fontSize: 12,
      color: 'red',
      marginTop: 5,
      marginLeft: 10,
    },
    mandatoryText:{ 
      color: "#db1a1a",
       fontSize:15,
       fontWeight:"500" 
      },
    widgetTitle: {
      color: "#999",
      fontFamily: "Inter",
      fontSize: 13,
      marginVertical: 10,
    },
    text: {
      fontSize: 30,
      color: "white",
    },
    stepWidget: {
      backgroundColor: "#fff",
      borderRadius: 10,
      padding: 10,
      marginTop: 10,
      width: "100%",
      marginLeft: 30,
      minHeight: 300,
    },
    stepText: {
      color: "#c32b2c",
      fontFamily: "Inter",
      fontSize: 14,
    },
    stepTitle: {
      color: "#5f5f5f",
      fontFamily: "Inter",
      fontSize: 16,
      marginVertical: 8,
    },
    cardHieghtStyle: { height: 210 },
    stepDesk: {
      color: "#757575",
      fontFamily: "Inter",
      fontSize: 12,
      marginBottom: 8,
      width: "80%",
    },
    inputBox: {
      flexDirection: "row",
      alignItems: "center",
      marginVertical: 10,
    },
    btnBox: {
      alignSelf: "center",
      marginHorizontal: 10,
      marginTop: -15,
    },
    buttonAddVehicleDisable: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 30,
      width: 108.3,
      height: 40.7,
      borderRadius: 18,
      backgroundColor: "#e0e2e5",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    step1: {
      flex: 0.4,
      minHeight: 200,
      paddingLeft: 28,
      marginLeft: 10,
    },
    step2: {
      flex: 0.5,
      minHeight: 200,
    },
    tableData: {
      backgroundColor: "#d6d6d6",
      borderRadius: 5,
      padding: 10,
      marginTop: 10,
      width: "100%",
    },
    tableRow: {
      flexDirection: "row",
      justifyContent: "space-around",
      marginVertical: 3,
    },
    tableColumn: {
      color: "#02122c",
      fontFamily: "Inter",
      fontSize: 13,
    },
    warningBox: {
      flexDirection: "row",
      alignItems: "center",
      marginVertical: 14,
      width: "70%",
    },
    warningText: {
      color: "#949494",
      fontFamily: "Inter",
      fontSize: 11,
      marginLeft: 6,
    },

    paymentBreakupTop: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: 30,
      borderColor: "#ccd0d5",
      borderBottomWidth: 1,
      marginBottom: 5,
      paddingVertical: 3,
    },
    paymentBreakupMdl: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: 30,
      paddingVertical: 2,
    },
    paymentBreakupBtm: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginRight: 30,
      borderColor: "#ccd0d5",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      paddingVertical: 4,
      marginTop: 5,
      marginBottom: 10,
    },
    paymntText: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "#02122c",
    },
    paymntTextMdl: {
      fontFamily: "Inter",
      fontSize: 12,
      color: "#02122c",
      opacity: 0.6,
      marginTop: 3,
    },
    paymntTextBtm: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "#02122c",
      opacity: 0.8,
      marginVertical: 5,
    },
    paymntTextBtmAmnt: {
      fontFamily: "Inter",
      fontSize: 16,
      color: "#38842a",
    },
    addressWidget: {
      backgroundColor: "rgba(216, 216, 216, 0.6)",
      borderRadius: 10,
      borderColor: "rgba(120, 120, 120, 0.2)",
      borderWidth: 1,
      paddingVertical: 15,
      paddingHorizontal: 15,
    },
    changeLinkWidget: {
      alignSelf: "flex-end",
    },
    changeLink: {
      color: "#bd2d37",
      fontFamily: "Inter",
      fontSize: 12,
    },
    nameText: {
      fontFamily: "Inter",
      fontSize: 13,
      color: "#02122c",
      opacity: 0.8,
      fontWeight: 600,
    },
    adresText: {
      color: "#02122c",
      fontFamily: "Inter",
      fontSize: 13,
      marginTop: 10,
      width: "80%",
    },
    buttonContainerStyle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      alignSelf: "center",
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#16ac39",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    buttonContainerStyle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#16ac39",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    buttonAddVehicle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#bd2d37",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "95%",
      height: "100%",
      top: 0,
      left: 30,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    loaderBg: {
      backgroundColor: "white",
      width: "50%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      minHeight: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    enterOtpTextStyle: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 21,
      letterSpacing: 0.64,
      textAlign: "center",
      color: "#66625f",
      paddingTop: 20,
    },
    otpDescTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "center",
      color: "#02122c",
      paddingTop: 10,

      marginHorizontal: 30,
    },
    otpInputViewStyle: {
      width: 250.4,
      height: 38,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 1.5,
      borderColor: "#dfdfdf",
      fontFamily: "Inter",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 3.6,
      textAlign: "left",
      color: "#66625f",
      borderRadius: 5,
      marginTop: 20,
      alignSelf: "center",
      paddingLeft: 10,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
      marginTop: 5,
    },
    timerTextStyle: {
      opacity: 0.5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    resendTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#bd2d37",
    },
    inputGroupWidget: {
      flexDirection: "row",
    },
    inputGroup: {
      flexDirection: "row",
      alignItems: "center",
      marginRight: 20,
    },
    inputLable: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      marginRight: 10,
      color: "#02122c",
      minWidth: 100,
      textAlign: "right",
      opacity: 0.8,
    },
    manageAutoButton: {
      width: 130,
      height: 35,
      borderRadius: 22,
      border: "solid 2px #bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },
    mabLabel: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      color: "#bd2d37",
    },
    addressFooterWidget: {
      width: 123.5,
      height: 36,
      alignSelf: "center",
      marginTop: 20,
      flexDirection: "row",
      marginBottom: 30,
      marginRight: "15%",
    },
  },

  {
    [DEVICE_SIZES.XL]: {
      stepWidget: {
        flexDirection: "row",
        width: "95%",
        alignSelf: "flex-start",
      },
    },
    [DEVICE_SIZES.LG]: {
      stepWidget: {
        flexDirection: "column",
        maxWidth: 990,
        width: "90%",
        alignSelf: "flex-start",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flexDirection: "column",
      },
      stepWidget: {
        flexDirection: "column",
        maxWidth: 700,
        width: "70%",
        alignSelf: "flex-start",
      },
      tableData: {
        width: "50%",
      },
      inputBox: {
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: 300,
      },
      btnBox: {
        marginTop: 0,
        marginBottom: 10,
      },
      step1: {
        marginBottom: 30,
        minHeight: 350,
      },
      step2: {
        marginTop: 30,
        paddingLeft: 30,
      },
      warningBox: {
        marginVertical: 20,
      },
      inputGroupWidget: {
        flexDirection: "column",
      },
      inputGroup: {
        flexDirection: "column",
        justifyContent: "center",
      },
      addressFooterWidget: {
        alignSelf: "flex-start",
        marginRight: 0,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: 10,
      },
      backBtnWidget: {
        flexDirection: "row",
        alignItems: "center",
      },
      widgetTitle: {
        color: "#999",
        fontFamily: "Inter-Regular",
        fontSize: 13,
        marginVertical: 10,
      },
      text: {
        fontSize: 30,
        color: "white",
      },
      wide90: {
        width: "90%",
      },
      stepWidget: {
        backgroundColor: "#fff",
        borderRadius: 10,
        padding: 10,
        marginTop: 10,
        width: "100%",
        marginLeft: 0,
        minHeight: 300,
      },
      stepText: {
        color: "#c32b2c",
        fontFamily: "Inter-Regular",
        fontSize: 14,
      },
      stepTitle: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 16,
        marginVertical: 8,
      },
      stepDesk: {
        color: "#757575",
        fontFamily: "Inter-Regular",
        fontSize: 12,
        marginBottom: 8,
        width: "80%",
      },
      inputBox: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 10,
      },
      btnBox: {
        alignSelf: "center",
        marginHorizontal: 10,
        marginTop: -15,
      },
      buttonAddVehicleDisable: {
        alignSelf: "flex-end",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 30,
        width: 108.3,
        height: 40.7,
        borderRadius: 18,
        backgroundColor: "#e0e2e5",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      step1: {
        flex: 0.4,
        minHeight: 200,
        marginLeft: 15,
      },
      step2: {
        flex: 0.5,
        minHeight: 200,
        marginLeft: 15,
        marginRight: 20,
        marginTop: 70,
      },
      cardHieghtStyle: { height: 150, marginLeft: -30 },
      tableData: {
        backgroundColor: "#d8d8d8",
        borderRadius: 5,
        padding: 10,
        marginTop: 10,
        width: "100%",
        borderWidth: 1,
        borderColor: "#787878",
      },
      tableRow: {
        flexDirection: "row",
        justifyContent: "space-around",
        marginVertical: 3,
      },
      tableColumn: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 13,
      },
      warningBox: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 14,
        width: "70%",
      },
      warningText: {
        color: "#949494",
        fontFamily: "Inter-Regular",
        fontSize: 11,
        marginLeft: 6,
      },

      paymentBreakupTop: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginRight: 30,
        borderColor: "#ccd0d5",
        borderBottomWidth: 1,
        marginBottom: 5,
        paddingVertical: 3,
      },
      paymentBreakupMdl: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginRight: 30,
        paddingVertical: 2,
      },
      paymentBreakupBtm: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginRight: 30,
        borderColor: "#ccd0d5",
        borderTopWidth: 1,
        borderBottomWidth: 1,
        paddingVertical: 4,
        marginTop: 5,
        marginBottom: 10,
      },
      paymntText: {
        fontFamily: "Inter",
        fontSize: 16,
        color: "#02122c",
      },
      paymntTextMdl: {
        fontFamily: "Inter",
        fontSize: 12,
        color: "#02122c",
        opacity: 0.6,
        marginTop: 3,
      },
      paymntTextBtm: {
        fontFamily: "Inter",
        fontSize: 17,
        color: "#02122c",
        opacity: 0.8,
        marginVertical: 7,
      },
      paymntTextBtmAmnt: {
        fontFamily: "Inter",
        fontSize: 17,
        color: "#38842a",
      },
      addressWidget: {
        backgroundColor: "rgba(216, 216, 216, 0.4)",
        borderRadius: 10,
        borderColor: "rgba(120, 120, 120, 0.5)",
        borderWidth: 1,
        paddingVertical: 15,
        paddingHorizontal: 15,
      },
      changeLinkWidget: {
        marginRight: 15,
      },
      changeLink: {
        color: "#bd2d37",
        fontFamily: "Inter-Regular",
        fontSize: 13,
      },
      nameText: {
        fontFamily: "Inter",
        fontSize: 13,
        color: "#02122c",
        opacity: 0.8,
        fontWeight: "600",
      },
      adresText: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 13,
        marginTop: 10,
        width: "80%",
      },
      buttonContainerStyle: {
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        alignSelf: "center",
        width: 150,
        height: 37,
        borderRadius: 18,
        backgroundColor: "#16ac39",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      buttonAddVehicle: {
        alignSelf: "flex-end",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        width: 200,
        height: 35.7,
        borderRadius: 18,
        backgroundColor: "#bd2d37",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 15,
      },
      overlayContainer: {
        width: "100%",
        height: "100%",
        zIndex: 99999,
      },
      overlay: {
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      },
      loaderBg: {
        backgroundColor: "white",
        width: "50%",
        borderRadius: 20,
        justifyContent: "flex-start",
        alignItems: "center",
        shadowColor: "rgba(0,0,0,0.05)",
        shadowOpacity: 1.5,
        elevation: 12,
        shadowRadius: 20,
        shadowOffset: { width: 1, height: 13 },
      },
      overlayContentViewStyle: {
        width: "95%",
        minHeight: 269.7,
        borderRadius: 13,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.05)",
        shadowOffset: {
          width: 0,
          height: 27,
        },
        shadowRadius: 34,
        shadowOpacity: 1,
      },
      enterOtpTextStyle: {
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: "bold",
        fontStyle: "normal",
        lineHeight: 21,
        letterSpacing: 0.64,
        textAlign: "center",
        color: "#66625f",
        paddingTop: 20,
      },
      otpDescTextStyle: {
        opacity: 0.5,
        fontFamily: "Inter-Regular",
        fontSize: 14,
        fontWeight: "500",
        fontStyle: "normal",
        lineHeight: 16,
        letterSpacing: 0,
        textAlign: "center",
        color: "#02122c",
        paddingTop: 10,

        marginHorizontal: 30,
      },
      otpInputViewStyle: {
        width: 250.4,
        height: 38,
        backgroundColor: "rgba(0, 0, 0, 0)",
        borderStyle: "solid",
        borderWidth: 1.5,
        borderColor: "#dfdfdf",
        fontFamily: "Inter-Regular",
        fontSize: 18,
        fontWeight: "bold",
        fontStyle: "normal",
        lineHeight: 14,
        letterSpacing: 3.6,
        textAlign: "left",
        color: "#66625f",
        borderRadius: 5,
        marginTop: 20,
        alignSelf: "center",
        paddingLeft: 10,
      },
      resendViewStyle: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginHorizontal: "15%",
        marginTop: 5,
      },
      timerTextStyle: {
        opacity: 0.5,
        fontFamily: "Inter-Regular",
        fontSize: 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "left",
        color: "#02122c",
      },
      resendTextStyle: {
        fontFamily: "Inter-Regular",
        fontSize: 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "left",
        color: "#bd2d37",
      },
      inputGroupWidget: {
        flexDirection: "column",
      },
      inputGroup: {
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        marginTop: -10,
      },
      inputLable: {
        fontFamily: "Inter-Regular",
        fontSize: 13,
        fontWeight: "normal",
        marginLeft: 10,
        color: "#02122c",
        minWidth: "90%",
        textAlign: "left",
        opacity: 0.8,
        marginBottom: 5,
        marginTop: 10,
      },
      manageAutoButton: {
        width: 130,
        height: 35,
        borderRadius: 22,
        border: "solid 2px #bd2d37",
        alignItems: "center",
        justifyContent: "center",
      },
      mabLabel: {
        fontFamily: "Inter-Regular",
        fontSize: 15,
        fontWeight: "bold",
        color: "#bd2d37",
      },
      addressFooterWidget: {
        width: "25%",
        height: 40,
        alignSelf: "flex-start",
        flexDirection: "row",
        marginBottom: 30,
        marginLeft: 40,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flexDirection: "column",
      },
      stepWidget: {
        flexDirection: "column",
        width: "70%",
        alignSelf: "flex-start",
      },
      tableData: {
        width: "50%",
      },
      step1: {
        marginBottom: 30,
        minHeight: 350,
      },
      inputGroupWidget: {
        flexDirection: "column",
      },
      inputGroup: {
        flexDirection: "column",
        justifyContent: "center",
      },
    },
  }
);
export default useStyles;
